import { render, staticRenderFns } from "./SanctionSearch.vue?vue&type=template&id=51d7054a&scoped=true"
import script from "./SanctionSearch.vue?vue&type=script&lang=js"
export * from "./SanctionSearch.vue?vue&type=script&lang=js"
import style0 from "./SanctionSearch.vue?vue&type=style&index=0&id=51d7054a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d7054a",
  null
  
)

export default component.exports